export interface PlayerAllSearchParams {
  tvshowId?: number | string | null
  seasonId?: number | string | null
  episodeId?: number | string | null
  channelId?: number | string | null
  showIndex?: number | string | null
  categoryId?: number | string | null
  vodId?: number | string | null
  channelNumber?: number | string | null
  featured?: boolean | null
  favorite?: boolean
  purchased?: boolean
  recommended?: boolean
  recentlyWatched?: boolean
  fromSearch?: boolean
  collectionId?: string | null
}

export interface SearchParamsForPath {
  params: PlayerAllSearchParams
  path: string
}

export const PlayerSubRoute = {
  VOD: 'vod',
  SHOW: 'show',
  TV: 'tv',
  EVENT: 'event',
} as const
export type PlayerSubRoute =
  (typeof PlayerSubRoute)[keyof typeof PlayerSubRoute]
